export enum LocaleKeyEnum {
  enUS = 'en-US',
  deDE = 'de-DE',
  frFR = 'fr-FR',
  itIT = 'it-IT',
  plPL = 'pl-PL',
  csCZ = 'cs-CZ',
}
